module.exports = __webpack_public_path__ + "img/tv.33e90f46.svg";